const CONTROL_SELECTOR =
  'a, button, input, select, textarea, label, [role="menu"], [role="menuitem"], [role="checkbox"], [role="switch"], [role="option"], [role="combobox"]'

/** Row click handler: forwards a plain left click to the row's `[data-row-primary]` control. */
export function activateRowPrimary(event: MouseEvent): void {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  const row = event.currentTarget
  if (!(row instanceof HTMLElement)) return
  const control = event.target instanceof Element ? event.target.closest(CONTROL_SELECTOR) : null
  if (control !== null && row.contains(control)) return
  if ((globalThis.getSelection?.()?.toString() ?? '') !== '') return
  row.querySelector<HTMLElement>('[data-row-primary]')?.click()
}
